import { useState, useCallback } from 'react';
import ProtocolService from '../../service';

export const useSearchProtocols = (onlySubprotocols = false) => {
  const [timeoutID, setTimeoutID] = useState(null);
  const [isSearching, setIsSearching] = useState(false);

  const findProtocols = useCallback(
    async (search, recordTypeId) => {
      const params = {
        protocolTextQuery: search,
        recordTypeId: recordTypeId,
        onlySubprotocols: onlySubprotocols
      };
      try {
        const response = await ProtocolService.getProtocolsAllRecordType(
          params
        );
        return response;
      } catch (error) {
        return null;
      }
    },
    [onlySubprotocols]
  );

  const handleGetProtocols = useCallback(
    async (search, recordTypeId) => {
      try {
        if (!search || !recordTypeId) return [];
        setIsSearching(true);
        const protocols = await findProtocols(search, recordTypeId);
        return protocols.data.content;
      } catch (error) {
        return [];
      } finally {
        setIsSearching(false);
      }
    },
    [findProtocols]
  );

  const filterProtocols = useCallback(
    async (search, recordTypeId) => {
      if (!search || !recordTypeId) {
        return Promise.resolve([]);
      }

      return new Promise((resolve, reject) => {
        try {
          if (typeof timeoutID === 'number') {
            clearTimeout(timeoutID);
          }

          setTimeoutID(
            setTimeout(async () => {
              const data = await handleGetProtocols(search, recordTypeId);
              resolve(data);
            }, 1000)
          );
        } catch (error) {
          reject(error);
        }
      });
    },
    [handleGetProtocols, timeoutID]
  );

  return {
    isSearching,
    filterProtocols
  };
};
